<template>
<b-container
  class="py-5 d-flex section"
  style="background-color: #585aff;"
  fluid
  >
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      
      <b-container
				class="p-3 p-sm-5 text-light"  
				fluid
			>
				<b-row>
					<b-col>
						<div class="d-flex pb-md-5">
							<div class="mx-auto headline-wrapper">
								<h1 class="font-weight-bold">
									Imagine ...
									<br>Your Data, Storage Location &amp; Applications
									<br>working independently of each other
								</h1>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col
						cols="12"
						md="4"
						xl="2"
						offset-xl="2"
						class="py-5 py-md-0"
						>
						<div class="text-center">
							<slot name="image">
								<b-img
									:src="require('../assets/how-to-pod.png')"
									style="max-width: 200px; width: 100%; height: auto;"
									/>
							</slot>
						</div>
					</b-col>
					<b-col
						cols="12"
						md="8"
						xl="5"
						class="pb-3"
						>
						<p>When you use a Solid App, it stores your data in your TrinPod<sup>&trade;</sup>.
							Now all other Solid Apps, given your permission, can use that data.
							You can freely switch between different Apps that all can access the data you created in your Solid App.
							And you can even move your Data to other Solid Pods by other Pod providers than Graphmetrix, and continue using your data.</p>
						
						<p>Example.
							<br>
							If you today post a picture with a comment on Facebook to a friend, Facebook owns that picture. The picture, the comment, and your friend relationship are stuck in the Facebook Silo.
							Imagine if you could fire up another Social media App, and if you choose to, have it access your post, with the picture, your comment, and even your friend.</p>
						<p>Or,
							<br>
							if you are working on a project and use an App to make a technical drawing, you and your colleagues post comments about the drawing.  Without moving the drawing into another App causing you to have two versions of it, you can open that drawing with another App right from your TrinPod<sup>&trade;</sup>, and not only have the drawing but the version history and comments available to that App.
							No duplication of data, no data synchronization headaches, no data stuck in an App Silo.</p>
					</b-col>
				</b-row>
      </b-container>

    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "Imagine"
}
</script>

<style scoped>
@media (max-width: 575px) {
	.headline-wrapper > h1 {
		font-size: 2rem !important;
	}
}
</style>
